<!-- 节庆热点 -->
<template>
  <div class="category-management">
    <page-title title="筛选">
      <el-button type="primary" @click="openDialog('add')">定制套餐</el-button>
    </page-title>
    <page-title title="数据列表">
      <div class="category-management__body">
        <el-table
          v-loading="loading"
          :data="tableData"
          style="width: 100%"
          :header-cell-style="{ backgroundColor: `#f7f7f7` }"
        >
          <el-table-column
            type="index"
            label="序号"
            width="100"
          ></el-table-column>
          <el-table-column
            prop="menuName"
            label="套餐名称"
            width="150"
          ></el-table-column>
          <el-table-column prop="mealType" label="套餐类型">
            <template slot-scope="scope">
              <span>{{ mealType[scope.row.mealType] || "--" }}</span>
            </template>
          </el-table-column>

          <el-table-column prop="type" label="套餐内容">
            <template slot-scope="{ row }">
              <div>
                <div v-for="item in row.menuGrantChild" :key="item.id">
                  {{ item.menuType }}: {{ item.count }}张￥{{ item.price }};
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="totalPrice" label="总价">
            <template slot-scope="{ row }"> ￥{{ row.totalPrice }} </template>
          </el-table-column>
          <el-table-column prop="phone" label="创建人"></el-table-column>
          <el-table-column width="400" prop="createTime" label="创建时间">
            <template slot-scope="{ row }"> {{ row.createTime }} </template>
          </el-table-column>
          <el-table-column fixed="right" label="操作" width="270">
            <template slot-scope="scope">
              <el-button
                class="edit"
                type="text"
                @click="openDialog('detail', scope.row)"
                >详情</el-button
              >
              <el-button
                class="edit"
                type="text"
                @click="openGrantDialog(scope.row)"
                >发放</el-button
              >
              <el-button
                class="edit"
                type="text"
                @click="openDialog('edit', scope.row)"
                >编辑</el-button
              >
              <el-button
                class="edit"
                type="text"
                @click="openRecordDialog(scope.row)"
                >操作记录</el-button
              >
              <el-button class="edit" type="text" @click="deleteRow(scope.row)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <cus-pagination
          :total="total"
          :current-page.sync="currentPage"
          :page-size.sync="pageSize"
          @size-change="getList"
        ></cus-pagination>
      </div>
    </page-title>
    <packageForm
      v-if="dialogVisible"
      :dialogMode="dialogMode"
      :currentData="currentData"
      :mangerPhones="mangerPhones"
      @refresh="getList"
      :visible.sync="dialogVisible"
    ></packageForm>
    <record-dialog
      :visible.sync="recordDialogVisible"
      :id="currentRecordId"
      @close="handleRecordDialogClose"
    ></record-dialog>
    <grant-dialog
      :visible.sync="grantDialogVisible"
      :grantForm="grantForm"
      @close="handleGrantDialogClose"
      @grant="handleGrant"
    ></grant-dialog>
  </div>
</template>

<script>
import { mealType } from "@/utils/enum";

import PageTitle from "@/components/pageTitle.vue";
import CusPagination from "@/components/cusPagination.vue";
import {
  getMadeList,
  deleteGrant,
  grant,
  certificationByPhone,
} from "@/api/package";
import packageForm from "./components/packageForm.vue";
import { Message } from "element-ui";
import RecordDialog from "./components/recordDialog.vue";
import GrantDialog from "./components/grantDialog.vue";
import dayjs from "dayjs";
import { admins } from "@/api/url";
export default {
  components: {
    PageTitle,
    CusPagination,
    packageForm,
    RecordDialog,
    GrantDialog,
  },
  data() {
    return {
      mealType,
      mangerPhones: [],
      loading: true,
      filter: {
        type: "",
      },
      tableData: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      dialogVisible: false,
      dialogMode: "add", // 默认模式
      currentData: {}, // 当前表单数据
      recordDialogVisible: false,
      currentRecordId: "", // 当前查看记录的ID
      grantDialogVisible: false, // 发放弹窗显示状态
      grantForm: {
        phone: "", // 用户手机号
        remark: "", // 备注信息
        payType: "0",
      },
      currentGrantData: null, // 当前要发放的套餐数据
    };
  },
  watch: {
    currentPage() {
      this.getList();
    },
  },
  created() {
    this.getMangerList();
  },
  methods: {
    async getList() {
      this.loading = true;
      const { data } = await this.$ajax.get(getMadeList, {
        pageSize: this.pageSize,
        pageOn: this.currentPage,
        type: this.filter.type,
      });
      this.tableData = data?.data?.records || [];
      this.total = data?.data?.total || 0;
      this.loading = false;
    },
    search() {
      this.currentPage = 1;
      (this.pageSize = 10), this.getList();
    },
    reset() {
      this.filter.type = "";
      this.getList();
    },
    /**
     * 删除
     */
    deleteRow(row) {
      this.$confirm("确认删除该项吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          console.log("row.id", row.id);
          this.handleDelete(row.id);
        })
        .catch((action) => {
          if (action === "cancel") {
            Message.info("删除已取消");
          }
        });
    },
    handleDelete(id) {
      this.$ajax
        .delete(deleteGrant(id), {})
        .then((res) => {
          if (res.data.code === 200) {
            Message.success("删除成功");
            this.getList();
          } else {
            Message.error(res.data.message || "删除失败");
          }
        })
        .catch((error) => {
          Message.error("删除失败：" + (error.message || "未知错误"));
        });
    },
    openDialog(mode, data = {}) {
      console.log("data", data);
      this.dialogMode = mode;
      this.currentData = { ...data };
      this.dialogVisible = true;
    },
    openRecordDialog(row) {
      this.currentRecordId = row.id;
      this.recordDialogVisible = true;
    },
    handleRecordDialogClose() {
      this.recordDialogVisible = false;
      this.currentRecordId = "";
    },
    openGrantDialog(row) {
      this.currentGrantData = row;
      this.grantForm = {
        phone: "",
        remark: "",
        payType: "1",
      };
      this.grantDialogVisible = true;
    },
    handleGrantDialogClose() {
      this.grantDialogVisible = false;
      this.grantForm = {
        phone: "",
        remark: "",
        payType: "1",
      };
    },
    async handleGrant(formData) {
      if (!formData.phone) {
        this.$message.warning("请输入用户手机号");
        return;
      }

      // 添加手机号格式验证
      const phoneRegex = /^1[3-9]\d{9}$/;
      if (!phoneRegex.test(formData.phone)) {
        this.$message.warning("请输入正确的手机号格式");
        return;
      }

      try {
        // 先尝试从 sessionStorage 获取用户信息
        let currentUserInfo = sessionStorage.getItem("currentUserInfo");

        if (!currentUserInfo) {
          // sessionStorage 中没有用户信息，调用认证接口
          const certRes = await this.$ajax.get(
            certificationByPhone(formData.phone)
          );
          if (certRes.data.code === 200) {
            currentUserInfo = certRes.data.data;
          } else {
            this.$message.error(certRes.data.msg || "获取用户信息失败");
            return;
          }
        } else {
          currentUserInfo = JSON.parse(currentUserInfo);
        }

        // 检查用户认证状态
        if (currentUserInfo.state !== "CERTIFIED") {
          this.$message.warning("该用户未进行身份认证或认证未通过");
          return;
        }

        // 添加确认对话框
        try {
          await this.$confirm(
            `发放成功后，${
              formData.payType == 0
                ? "用户账户将拥有该套餐"
                : "用户端将收到该笔待支付套餐"
            }，确认发放?`,
            "发放",
            {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
            }
          );
          const currentMenuGrantChild = this.currentGrantData.menuGrantChild.map(
            (item) => {
              // 解析原始的 expirationDate
              const [startDate, endDate] = item.expirationDate.split(" - ");

              // 计算原始时间范围的天数
              const daysDiff = dayjs(endDate).diff(dayjs(startDate), "day");
              console.log("daysDiff", daysDiff);
              // 获取当前日期作为新的开始日期
              const today = dayjs();
              const newStartDate = today.format("YYYY-MM-DD");

              // 计算新的结束日期
              const newEndDate = today
                .add(daysDiff, "day")
                .format("YYYY-MM-DD");

              // 计算新的 overTime（结束日期后一天）
              const newOverTime = today
                .add(daysDiff + 1, "day")
                .format("YYYY-MM-DD");

              return {
                allPrice: item.allPrice,
                count: item.count,
                price: item.price,
                menuType: item.menuType,
                expirationDate: `${newStartDate} - ${newEndDate}`,
                overTime: newOverTime,
                mealType: this.currentGrantData.mealType,
              };
            }
          );
          const params = {
            grantId: this.currentGrantData.id,
            menuGrantChildVos: currentMenuGrantChild,
            phone: formData.phone,
            remark: formData.remark,
            payType: +formData.payType,
            totalPrice: this.currentGrantData.totalPrice,
          };
          const res = await this.$ajax.post(grant, params);

          if (res.data.code === 200) {
            this.$message.success("发放成功");
            this.grantDialogVisible = false;
            this.getList(); // 刷新列表
          } else {
            this.$message.error(res.data.msg || "发放失败");
          }
        } catch (error) {
          if (error === "cancel") {
            this.$message.info("已取消发放");
            return;
          }
          throw error;
        }
      } catch (error) {
        this.$message.error("发放失败：" + (error.message || "未知错误"));
      }
    },
    getMangerList() {
      let data = {
        pageNumber: 1,
        pageSize: 999,
      };
      this.$ajax.get(admins, data).then(
        (res) => {
          console.log(`res----------`, res);
          if (res.status == 200) {
            this.mangerPhones = res.data.rows;
            console.log(`'222222222'`, this.mangerPhones);
          }
        },
        (err) => {
          console.log(err);
          this.$message({
            showClose: true,
            message: err,
            type: "error",
            center: true,
            duration: 3000,
          });
        }
      );
    },
  },
  mounted() {
    this.getList();
  },
};
</script>

<style lang="scss" scoped>
.category-management {
  .box-card {
    margin-bottom: 20px;
  }

  &__filter-header {
    display: flex;
    align-items: center;
  }

  &__body {
    .edit {
      color: #005bff;
    }

    .el-button.is-disabled {
      color: #c0c4cc;
      cursor: not-allowed;
    }

    .el-switch__label {
      color: #333333;
    }

    .el-table {
      border: 1px solid #ebeef5;
      border-bottom: none;
      margin-bottom: 20px;
    }
  }
}
</style>
